import { useForm } from "react-hook-form";
import { Input } from "../../Input";
import { ButtonGroup } from "../../../Buttons/ButtonGroup";
import { useUpdatePaymentMethod } from "../../../../api/hooks";

export function SaveBillingDetailsForm({ payment, setOpen }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      name: payment.billing_details?.name || "",
      zip: payment.billing_details?.address?.postal_code || "",
      country: payment.billing_details?.address?.country || "",
    },
  });

  const { mutateAsync: updatePayment, isLoading } = useUpdatePaymentMethod();

  const onSubmit = async (data) => {
    await updatePayment({ paymentMethodId: payment.id, billing: data });
    setOpen(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-4">
      <Input label="Name" name="name" control={control} />
      <Input label="ZIP / Postal Code" name="zip" control={control} />
      <Input label="Country" name="country" control={control} />

      <div className="mt-4">
        <ButtonGroup
          primaryButtonText="Save"
          primaryButtonOnClick={handleSubmit(onSubmit)}
          secondaryButtonText="Cancel"
          secondaryButtonOnClick={() => setOpen(false)}
          isLoading={isLoading}
        />
      </div>
    </form>
  );
}